import { z } from 'zod'

export const ProductConditionTranslationSchema = z.object({
  code: z.string(),
  title: z.string(),
  description: z.string().optional(),
})
export type ProductConditionTranslation = z.infer<
  typeof ProductConditionTranslationSchema
>
export const ConditionsResponseSchema = z.array(
  ProductConditionTranslationSchema
)
export type Condition = z.infer<typeof ProductConditionTranslationSchema>
export type ConditionsResponse = z.infer<typeof ConditionsResponseSchema>
